<template>
  <div v-if="rows && rows.length">
    <div
      class="edit_app_info flex flex--top"
      v-for="(info, index) in rows"
      :key="index"
    >
      <div class="edit_app_info1 mobile_only">
        <!-- {{
          `${info.side} | ${getCategoryNameByCode(info.category)} ${
            info.code_name_hospital
          } ${info.code_name_clinical} ${info.duration} `
        }} -->
        {{
          `${info.is_primary ? "✓ ראשי |" : ""} ${info.side} ${
            info.code_name_hospital
          } ${info.code_name_clinical} ${info.duration} `
        }}
      </div>
      <div class="edit_app_info1 no_mobile desk-flex">
        <div class="surg_list-1">{{ `${info.is_primary ? "✓" : ""}` }}</div>
        <div class="surg_list-2">{{ `${info.side}` }}</div>
        <!-- <div class="surg_list-2">
          {{ `${getCategoryNameByCode(info.category)}` }}
        </div> -->
        <div class="surg_list-3">
          {{ `${info.code_name_hospital}` }}
        </div>
        <div class="surg_list-4">
          {{ `${info.code_name_clinical}` }}
        </div>
        <div class="surg_list-5">{{ `${info.duration}` }}</div>
      </div>
      <div v-show="!payment_token" class="edit_app_info2 flex flex--end">
        <!-- <a
          class="edit_pen svg-block"
          href="javascript:void(0)"
          @click="$emit('editSelectedBlock', index)"
        >
          <PenSvg />
        </a> -->
        <a
          class="edit_close_sur"
          href="javascript:void(0);"
          @click.prevent="$emit('removeSelectedBlock', index)"
        >
          <CloseSvg />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import PenSvg from "@/assets/img/svg/ic-pen.svg";
import CloseSvg from "@/assets/img/svg/close.svg";

export default {
  name: "SelectedSurgeryInfo",
  props: {
    surgery_categories: { required: true },
    rows: { required: true },
    payment_token: { required: true }
  },
  components: { CloseSvg },
  methods: {
    getCategoryNameByCode(code) {
      const find = this.surgery_categories.find(
        cat => cat.current_surgery_category_code == code
      );
      if (find) return find.current_surgery_category_name;
      return "";
    }
  }
};
</script>
